export default {
	serviceProvider: null,
	vuexModule: "companies",
	headerColumns: [
		{
			prop: "name",
			keys: ["name", "email_domain"],
			label: "Company",
			minWidth: 180,
			searchable: true,
			sortable: true,
		},
		{
			prop: "company_admin_list",
			keys: ["company_admin_list.name"],
			label: "Company Admin",
			minWidth: 260,
			searchable: true,
			sortable: true,
		},
		{
			prop: "user_count",
			label: "Users",
			minWidth: 150,
			class: "text-center",
			labelClass: "justify-content-center",
			sortable: true,
		},
		{
			prop: "report_count",
			label: "Reports",
			minWidth: 170,
			class: "text-center",
			labelClass: "justify-content-center",
			sortable: true,
		},
		{
			prop: "role",
			keys: ["role.role"],
			label: "Role",
			minWidth: 190,
			searchable: true,
			sortable: true,
			sortBy: "role.role",
		},
		{
			prop: "role_value",
			keys: ["role_value"],
			label: "Role Value",
			minWidth: 200,
			searchable: true,
			sortable: true,
		},
		{
			prop: "status",
			keys: ["status"],
			label: "Status",
			minWidth: 160,
			sortable: true,
		},
	],
	messages: {
		delete_text:
			"Deleting a company will also delete all user accounts. You won't be able to revert this.",
		bulk_delete_text:
			"Deleting a company will also delete all user accounts. You won't be able to revert this.",
	},
};
